/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const ISSUER_CAN_ABILITY = [
  ['read', 'MyProfile'],
  ['read', 'NotFound'],
  ['read', 'GenericReport'],
  ['read', 'OrganizationAdmin'],
  // ['read', 'AllUserList'],
  ['read', 'UserProfile'],
  ['read','PaymentTransaction'],
  ['read', 'MasterReport'],
  ['read', 'CredentialList'],
  ['read', 'CredentialDetail'],
  ['read','OrgAdminList'],
  ['read', 'ApplicationDetail'],

];  

export const ISSUER_CANNOT_ABILITY = [['read', 'MasterAdminInvite']];
